import React from 'react';

const Header = () => {
  return <header className="main-header">Main Header</header>;
};

export default Header;
